import React from 'react';
import Footer from './Footer';
import Header from './Header';
import { Helmet } from 'react-helmet';
import FooterIcon from '../../svg/FooterIcon';

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Consult FGC | Digital Marketing & SEO Company</title>

        <meta
          name="description"
          content="Consult FGC is a boutique digital marketing, SEO, web design, & web development company. We offer an experienced but personal touch to help meet your digital branding needs & grow your business."
        />
        <meta property="og:locale" content="en_US"></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:title"
          content="Consult FGC | Digital Marketing &amp; SEO Company"
        ></meta>
        <meta
          property="og:description"
          content="Consult FGC is a boutique digital marketing, SEO, web design, &amp; web development company. We offer an experienced but personal touch to help meet your digital branding needs &amp; grow your business."
        ></meta>
        <meta
          property="og:site_name"
          content="Consult FGC | Digital Marketing &amp; SEO Company"
        ></meta>
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          name="twitter:description"
          content="Consult FGC is a boutique digital marketing, SEO, web design, &amp; web development company. We offer an experienced but personal touch to help meet your digital branding needs &amp; grow your business."
        ></meta>
        <meta
          name="twitter:title"
          content="Consult FGC | Digital Marketing &amp; SEO Company"
        ></meta>
        <link
          rel="icon"
          href="https://consultfgc.netlify.app/static/ConsultFGC_Logo_footer-8b0c6cdcc10d6cc56b61a7b78ed851b7.png"
        />
      </Helmet>
      <Header />
      <main className="text-gray-900">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;

/* <svg class="trapezoidal-horizintal h-28 w-full bg-primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
preserveAspectRatio="none">
<polygon fill="#161e2e" points="0,100 100,0 100,100"/>
</svg>*/
